import ArtworkModalContent from "@/components/Design/ArtworkModalContent";
import { useSelector } from "react-redux";
import HeadlessModal from "./HeadlessModal";
import { Button } from "./SimpleButton";
import Link from "next/link";
import Order from "@/redux/models/Order";
import { cn } from "@/utils";
import { DesignShape } from "@/types";
import { isDesignCustomShape } from "@/utils/customShape";
import { TriangleAlert } from "lucide-react";

const ArtworkModal = ({
  open,
  setOpen,
  item,
  showEdit = false,
  showDelta = true,
}: {
  open: boolean;
  setOpen: (newState: boolean) => void;
  item: {
    design: {
      id: string;
      shape: DesignShape;
      front_proof: string | null;
      back_proof: string | null;
    };
    hcard_design?: {
      id: string;
      front_proof: string | null;
      back_proof: string | null;
      shape: DesignShape;
    } | null;
  };
  showEdit?: boolean;
  showDelta?: boolean;
}) => {
  const onClose = () => setOpen(false);
  const order = useSelector(Order.selectors.getOrder);

  if (!item) return null;

  const isCustomShape = isDesignCustomShape(item.design);
  return (
    <HeadlessModal
      isOpen={open}
      onClose={onClose}
      className="max-w-2xl"
      content={
        (
          <div className="flex flex-col">
            <div className="flex relative px-4 lg:px-8 py-8">
              <h4 className="text-left text-[20px] font-medium text-[#141414]">Preview</h4>
            </div>
            <div>
              {item.hcard_design && !item.hcard_design.front_proof && (
                <div className="bg-[#2463EB] bg-opacity-10 text-xs p-2 rounded-lg mt-2 px-4 mx-6 font-medium flex items-center justify-center gap-2 md:text-base border border-[#2463EB]">
                  <TriangleAlert />
                  Missing Retail Card Design. Please edit Retail Card.
                </div>
              )}
              <div className="flex items-center">
                <ArtworkModalContent
                  itemFront={item.design.front_proof!}
                  itemBack={item.design.back_proof!}
                  hcBackImg={item.hcard_design?.back_proof}
                  hcFrontImg={item.hcard_design?.front_proof}
                  defaultSelected={"front"}
                  isCustomShape={isCustomShape}
                  showDelta={showDelta}
                />
              </div>
            </div>
            <div
              className={cn(
                "flex justify-between pt-2 lg:pt-4 p-4 gap-1 lg:gap-4",
                !isCustomShape && "border-t border-gray-200",
                !item.hcard_design && "justify-end"
              )}
            >
              {!isCustomShape && showEdit && (
                <>
                  <Link
                    href={`/shop/stock-shape-car-air-fresheners/${order?.id}/${item.design.id}/design?redirectToCart=true`}
                  >
                    <Button outline onClick={() => undefined} className="w-full lg:w-auto" large>
                      Edit Freshener
                    </Button>
                  </Link>
                  {item.hcard_design && (
                    <Link
                      href={`/shop/stock-shape-car-air-fresheners/${order?.id}/${item.hcard_design.id}/design?redirectToCart=true`}
                    >
                      <Button outline onClick={() => undefined} className="w-full lg:w-auto" large>
                        Edit Retail Card
                      </Button>
                    </Link>
                  )}
                </>
              )}
              {!showEdit && (
                <div className="flex justify-end w-full">
                  <Button onClick={onClose} className="w-full lg:w-auto" large>
                    Okay
                  </Button>
                </div>
              )}
            </div>
          </div>
        ) as any
      }
    />
  );
};

export default ArtworkModal;
